"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapKeys = mapKeys;
exports.mapValue = mapValue;
exports.stringArrayIncludes = exports.compose = exports.pipe = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

require("@babel/polyfill/noConflict");

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _map = _interopRequireDefault(require("lodash/map"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Provides the functionality to pipe different functions together.
 *
 * e.g.
 * const f = pipe(a, b, c, d)
 * f(data) is the same as passing data through a then b then c then d.
 *
 * TODO: Type signature for pipe and compose is INSANELY difficult.
 */
var _pipe = function _pipe(a, b) {
  return function (arg) {
    return b(a(arg));
  };
};

var pipe = function pipe() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }

  return ops.reduce(_pipe);
};
/**
 * Pipe, but run in reverse - also known as compose
 */


exports.pipe = pipe;

var compose = function compose() {
  for (var _len2 = arguments.length, ops = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    ops[_key2] = arguments[_key2];
  }

  return pipe.apply(void 0, (0, _toConsumableArray2["default"])(ops.reverse()));
};
/**
 * HOF that creates a function that maps the key of the object according to
 * the function provided.
 */


exports.compose = compose;

function mapKeys(f) {
  function util(o) {
    if (Array.isArray(o)) {
      return o.map(function (v) {
        return util(v);
      });
    } else if (o != null && o.constructor === Object) {
      var mapped = Object.keys(o).reduce(function (res, key, index, arr) {
        return _objectSpread(_objectSpread({}, res), {}, (0, _defineProperty2["default"])({}, f(key), util(o[key])));
      }, {});
      return mapped;
    }

    return o;
  }

  return util;
}
/**
 * HOF that creates a function that modifies the value of the object according
 * to the function and keys provided.
 */


function mapValue(f) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();

  var iteratee = function iteratee(value, key) {
    if ((0, _isArray["default"])(value)) {
      return (0, _map["default"])(value, iteratee);
    } else if (_moment["default"].isMoment(value)) {
      return f(value);
    } else if ((0, _isObject["default"])(value)) {
      return (0, _mapValues["default"])(value, iteratee);
    } else if (keys.size === 0 || keys.has(key)) {
      return f(value);
    } else {
      return value;
    }
  };

  return function (o) {
    return (0, _mapValues["default"])(o, iteratee);
  };
}

var stringArrayIncludes = function stringArrayIncludes(data) {
  if (!data) {
    data = {
      strArray: [],
      matchStr: false,
      options: {}
    };
  }

  var _data = data,
      strArray = _data.strArray,
      matchStr = _data.matchStr,
      options = _data.options;

  if (typeof strArray === 'string') {
    strArray = [strArray];
  }

  if (!Array.isArray(strArray)) {
    return false;
  }

  if (typeof matchStr !== 'string') {
    return false;
  }

  var ignoreCase = (0, _get["default"])(options, 'ignoreCase', false);

  var _iterator = _createForOfIteratorHelper(strArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var str = _step.value;

      if (typeof str === 'string') {
        if (str.trim() === matchStr.trim()) {
          return true;
        }

        if (ignoreCase) {
          if (str.trim().toLocaleUpperCase() === matchStr.trim().toLocaleUpperCase()) {
            return true;
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};

exports.stringArrayIncludes = stringArrayIncludes;
//# sourceMappingURL=index.js.map